// extracted by mini-css-extract-plugin
module.exports = {"accordion":"Accordion_accordion__KPdgH","header":"Accordion_header__zXoBD","chevron":"Accordion_chevron__TCj89","flip":"Accordion_flip__kwC_m","content":"Accordion_content__9wUUK"};